import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface EntityHistoryContentDialogInput
{
    title: string;
    html: string;
}

/**
 * Read-only viewer for legacy-HTML payloads surfaced by the entity history
 * dialog (e.g. `legacy_violation_history.content` — the email body captured
 * when the notification was sent). Opens on top of the history dialog;
 * closing returns the user to the history list.
 *
 * Angular's default `[innerHTML]` sanitization strips dangerous tags
 * (script, on-handlers, javascript: URLs) while preserving the structural
 * markup these emails rely on (tables, paragraphs, anchors). No
 * `bypassSecurityTrustHtml` is used.
 */
@Component({
    selector: 'app-entity-history-content-dialog',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    templateUrl: './entity-history-content-dialog.component.html',
    styleUrls: ['./entity-history-content-dialog.component.scss'],
})
export class EntityHistoryContentDialogComponent
{
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: EntityHistoryContentDialogInput,
        public _dialogRef: MatDialogRef<EntityHistoryContentDialogComponent>,
    )
    {
    }
}
